import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ClientDashboard from "@/pages/ClientDashboard";
import NewBrief from "@/pages/NewBrief";
import BriefDetail from "@/pages/BriefDetail";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminVendors from "@/pages/AdminVendors";
import AdminOrders from "@/pages/AdminOrders";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminApplications from "@/pages/AdminApplications";
import Vendors from "@/pages/Vendors";
import Designers from "@/pages/Designers";
import StartupKit from "@/pages/StartupKit";
import LogoStudio from "@/pages/LogoStudio";
import MenuDesign from "@/pages/MenuDesign";
import DielineGallery from "@/pages/DielineGallery";
import DielineConfigurator from "@/pages/DielineConfigurator";
import BrandVideo from "@/pages/BrandVideo";
import ProductCategory from "@/pages/ProductCategory";
import AdminWhatsApp from "@/pages/AdminWhatsApp";
import AdminAssignments from "@/pages/AdminAssignments";
import DesignerDashboard from "@/pages/DesignerDashboard";
import VendorDashboard from "@/pages/VendorDashboard";
import InviteAccept from "@/pages/InviteAccept";
import AdminTeam from "@/pages/AdminTeam";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 pf-label">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/invite/:token" element={<InviteAccept />} />
            <Route path="/dashboard" element={<Protected><ClientDashboard /></Protected>} />
            <Route path="/brief/new" element={<Protected><NewBrief /></Protected>} />
            <Route path="/brief/:id" element={<Protected><BriefDetail /></Protected>} />
            <Route path="/orders" element={<Protected><Orders /></Protected>} />
            <Route path="/orders/:id" element={<Protected><OrderDetail /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
            <Route path="/admin/vendors" element={<Protected adminOnly><AdminVendors /></Protected>} />
            <Route path="/admin/orders" element={<Protected adminOnly><AdminOrders /></Protected>} />
            <Route path="/admin/customers" element={<Protected adminOnly><AdminCustomers /></Protected>} />
            <Route path="/admin/applications" element={<Protected adminOnly><AdminApplications /></Protected>} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/designers" element={<Designers />} />
            <Route path="/startup-kit" element={<StartupKit />} />
            <Route path="/logo-studio" element={<LogoStudio />} />
            <Route path="/menu-design" element={<MenuDesign />} />
            <Route path="/dielines" element={<DielineGallery />} />
            <Route path="/dielines/:slug" element={<DielineConfigurator />} />
            <Route path="/brand/video" element={<BrandVideo />} />
            <Route path="/products/:slug" element={<ProductCategory />} />
            <Route path="/admin/whatsapp" element={<Protected adminOnly><AdminWhatsApp /></Protected>} />
            <Route path="/admin/assignments" element={<Protected adminOnly><AdminAssignments /></Protected>} />
            <Route path="/admin/team" element={<Protected adminOnly><AdminTeam /></Protected>} />
            <Route path="/designer" element={<Protected><DesignerDashboard /></Protected>} />
            <Route path="/vendor" element={<Protected><VendorDashboard /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
